import { employerService } from './employerService';

export * from './employerService';

export default employerService;
